import React from 'react';
import {FormattedMessage} from 'react-intl';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import ModalHeaderWithClose from 'components/ModalHeaderWithClose';
import {connect} from 'react-redux';
import {selectCardById} from 'state/card/cardSelectors';
import Icon from 'components/Icon';
import ListItem from 'components/ListItem';
import Busy from 'components/activity/Busy';
import {
  downloadCardExcel,
  downloadCardCsv,
  downloadCardPowerpoint,
} from 'state/cardExport/cardExportActions';
import {selectIsCardExportDownloading} from 'state/cardExport/cardExportSelectors';

class ExportModal extends React.Component {
  requestClose = () => this.props.onRequestModalClose();

  handleExcelClick = () =>
    this.props
      .downloadCardExcel(this.props.cardId, this.props.filters)
      .then(this.requestClose);

  handleCsvClick = () =>
    this.props
      .downloadCardCsv(this.props.cardId, this.props.filters)
      .then(this.requestClose);

  handlePowerpointClick = () =>
    this.props
      .downloadCardPowerpoint(this.props.cardId, this.props.filters)
      .then(this.requestClose);

  render() {
    const {isOpen, card, onRequestModalClose, isDownloading} = this.props;

    return (
      <Modal isOpen={isOpen}>
        <ModalHeaderWithClose onClose={onRequestModalClose}>
          <ModalHeader>
            <FormattedMessage
              id="ExportModal__Title"
              description="Title of modal to download card as an export"
              defaultMessage="Export {cardTitle}"
              values={{cardTitle: card ? card.title : ''}}
            />
          </ModalHeader>
        </ModalHeaderWithClose>
        <Busy isLoading={isDownloading}>
          <div>
            <ListItem
              image={
                <Icon icon={Icon.OPTIONS.EXCEL} size={Icon.SIZES.MEDIUM} />
              }
              onClick={this.handleExcelClick}
            >
              <FormattedMessage
                id="ExportModal__Excel"
                description="Export card as Excel spreadsheet"
                defaultMessage="Excel"
              />
            </ListItem>
            <ListItem
              onClick={this.handleCsvClick}
              image={
                <Icon icon={Icon.OPTIONS.TABLE} size={Icon.SIZES.MEDIUM} />
              }
            >
              <FormattedMessage
                id="ExportModal__CSV"
                description="Export card as Comma Separated Value (CSV) spreadsheet"
                defaultMessage="CSV"
              />
            </ListItem>
            <ListItem
              image={
                <Icon icon={Icon.OPTIONS.POWERPOINT} size={Icon.SIZES.MEDIUM} />
              }
              onClick={this.handlePowerpointClick}
            >
              <FormattedMessage
                id="ExportModal__Powerpoint"
                description="Download card as Powerpoint presentation"
                defaultMessage="PowerPoint"
              />
            </ListItem>
          </div>
        </Busy>
      </Modal>
    );
  }
}
export default connect(
  (state, {cardId}) => ({
    card: selectCardById(state, cardId),
    isDownloading: selectIsCardExportDownloading(state),
  }),
  {
    downloadCardExcel,
    downloadCardCsv,
    downloadCardPowerpoint,
  }
)(ExportModal);
